import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

export type ExportReport = Readonly<{
  key: string;
  label: string;
  description: string;
}>;

const reportStrings = appStrings.modules.coachingDashboard.reports;

// Reports to offer, in display order. Each entry pairs the export key with its copy.
export const EXPORT_REPORTS: readonly ExportReport[] = [
  { key: 'student-summary', ...reportStrings.items.studentSummary },
  { key: 'network-membership', ...reportStrings.items.networkMembership },
  { key: 'coach-matches', ...reportStrings.items.coachMatches },
  { key: 'bookmarks', ...reportStrings.items.bookmarks },
  { key: 'posts-comments', ...reportStrings.items.postsComments },
  { key: 'blueprint', ...reportStrings.items.blueprint },
  { key: 'ayot', ...reportStrings.items.ayot },
  { key: 'life-readiness', ...reportStrings.items.lifeReadiness },
];
